import CommonUtils from '../utils';

// Weex增量语言包 - APP磁盘存储键
export const WEEX_LANG_UPDATE_DISK = 'WEEX_LANG_UPDATE_DISK';

// Weex增量语言包时间戳 - APP磁盘存储键
export const WEEX_LANG_UPDATE_TIMESTAMP_DISK = 'WEEX_LANG_UPDATE_TIMESTAMP_DISK';

// Weex基础语言包时间戳，每次上架时更新
export const WEEX_LANG_BASE_TIMESTAMP = 1692080399103;

// 多语言平台应用系统
export const WEEX_LANG_SYSTEM = CommonUtils.isMSmartLife() ? 'SmartHome' : 'TSmartLife';

// 多语言平台业务类型
export const WEEX_LANG_APP = 'H5';
